import React from "react";
import { useTranslation, Trans } from "react-i18next";

export default function CheckNightAppointment({ bookingtime, deleteUser, cancelRequest, id }) {
    const { t } = useTranslation("clientBooking");
    return (
        <div className="confirm-delete-wrapper checkbooktime register-medium">
            <div data-backdrop="static" className="modal fade" id={id} role="dialog">
                <div className="modal-dialog    modal-dialog-preview ">
                    <div className="modal-content">
                        <div className="modal-body">
                            {/* <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div> */}
                            <p className="red margin-unset font-size-18 line-height-20px pt-5"><Trans i18nKey="nightAppointment.alert" ns="clientBooking" values={{ time: bookingtime }} components={{ img: <img src="localImages/moon.png" class="star-imh-moon" alt="time-image" /> }} /></p>
                            <h3>{t("nightAppointment.confirm")}</h3>
                            <div className="confirm-btn-box">
                                <div
                                    className="register-medium-confirnation"
                                    onClick={cancelRequest}
                                    data-dismiss="modal"
                                >
                                    {t("buttons.cancel")}
                                </div>
                                <div
                                    className="register-medium-confirnation"
                                    data-dismiss="modal"
                                    onClick={deleteUser}
                                >
                                    {t("buttons.confirm")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
